import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { ICountyListItem } from '@/api/types-fip'

export const defaultFipCountyData: ICountyListItem = {
  fipsState: 0,
  fipsCounty: 0,
  countyName: ''
}

export interface IFipCounties {
  FipCountyList: ICountyListItem[]
  FipCountySelected: (ICountyListItem | null)
  StateFips: number
}

@Module({ dynamic: true, store, name: 'FipCounties' })
class FipCounties extends VuexModule implements IFipCounties {
  public FipCountyList: ICountyListItem[] = []
  public FipCountySelected: ICountyListItem | null = null
  public StateFips = 0

  @Mutation
  private DEL_ALL_COUNTYLISTITEMS() {
    this.FipCountyList = []
    this.StateFips = 0
  }

  @Mutation
  private LOAD_COUNTYLISTITEMS(stateFips: number, fipCounties: ICountyListItem[]) {
    this.FipCountyList = fipCounties
    this.StateFips = stateFips
  }

  // GETTERS
  get cachedFipCounties() {
    return this.FipCountyList
  }

  get stateFips() {
    return this.StateFips
  }

  @Action
  public loadFipCounties(stateFips: number, fipCounties: ICountyListItem[]) {
    this.DEL_ALL_COUNTYLISTITEMS()
    this.LOAD_COUNTYLISTITEMS(stateFips, fipCounties)
  }

  @Action
  public clearList() {
    this.DEL_ALL_COUNTYLISTITEMS()
  }
}

export const FipCountyModule = getModule(FipCounties)
